var _excluded = ["data", "cardType", "sort", "statsTitle"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import RightChevron from '@domain-group/fe-co-icon/lib/js/chevron-right';
import { MediaContext } from 'react-media-query-hoc';
import Avatar from '@domain-group/fe-co-avatar';
import { useSendEvent, withEventBoundary } from '@domain-group/fe-co-allhomes-analytics';
import Stats from '@domain-group/fe-co-allhomes-agent-stats';
import { AgentAwardPill } from '@domain-group/fe-co-allhomes-shared-components';
var placeholder = "https://s.domainstatic.com.au/content/fe-static/@domain-group/fe-pa-allhomes-agency-search-results/static/placeholder_13c04f27.png";
import ContactButtons from './contact-buttons';
import * as styles from './card.style';
import { jsx as ___EmotionJSX } from "@emotion/core";
var Card = _ref => {
  var data = _ref.data,
    cardType = _ref.cardType,
    sort = _ref.sort,
    statsTitle = _ref.statsTitle,
    props = _objectWithoutProperties(_ref, _excluded);
  var _useSendEvent = useSendEvent(),
    sendEvent = _useSendEvent.sendEvent;
  var _useContext = useContext(MediaContext),
    mobile = _useContext.mobile;
  var agentStaffId = data.agentStaffId,
    agentStaffName = data.agentStaffName,
    agencyId = data.agencyId,
    agencyName = data.agencyName,
    agencyPhoto = data.agencyPhoto,
    _data$highlightedAwar = data.highlightedAwards,
    highlightedAwards = _data$highlightedAwar === void 0 ? [] : _data$highlightedAwar;
  var isAgencyCard = cardType === 'AGENCY';
  var cardName = isAgencyCard ? agencyName : agentStaffName;
  var sold = sort === 'SOLD' || sort === 'SOLD_TOTAL';
  var rented = sort === 'RENTED' || sort === 'RENTED_TOTAL';
  var development = sort === 'DEVELOPMENT' || sort === 'DEVELOPMENT_TOTAL';
  var sortAll = sort === 'SOLD_TOTAL' || sort === 'RENTED_TOTAL' || sort === 'DEVELOPMENT_TOTAL';
  var titleRight = () => {
    if (sold) {
      return 'Total Sales';
    }
    if (rented) {
      return 'Total Rentals';
    }
    return 'Total Sales (New Homes)';
  };
  var launchEnquiryModal = () => {
    sendEvent('launch-enquiry-modal');
    props.launchEmailEnquiryModal({
      agentStaffId,
      agentStaffName,
      agencyId,
      agencyName,
      title: "Contact ".concat(cardName),
      logo: agencyPhoto
    });
  };
  var renderAwards = withMargin => highlightedAwards.map(award => ___EmotionJSX("div", {
    css: styles.awardPill(withMargin)
  }, ___EmotionJSX(AgentAwardPill, {
    label: award.badgeLabel
  })));
  var getLogo = () => ___EmotionJSX("span", {
    css: styles.logoContainer
  }, agencyPhoto ? ___EmotionJSX("img", {
    src: agencyPhoto,
    alt: agencyName
  }) : ___EmotionJSX("img", {
    src: placeholder,
    alt: agencyName,
    css: styles.placeholder
  }));
  var getAvatar = () => ___EmotionJSX("span", {
    css: styles.avatarContainer
  }, !data.agentStaffPhotoSmall && ___EmotionJSX(Avatar, {
    size: "custom",
    colorScheme: "dark",
    shape: "circle",
    theme: "allhomes",
    css: styles.avatar
  }), data.agentStaffPhotoSmall && ___EmotionJSX("img", {
    css: styles.img,
    src: data.agentStaffPhotoSmall,
    alt: data.agentStaffName
  }));
  var getAgencyDetails = () => ___EmotionJSX("div", {
    css: styles.cardDetails
  }, ___EmotionJSX("div", null, ___EmotionJSX("a", {
    href: data.agencyUrl,
    css: styles.cardAnchor,
    onClick: () => sendEvent('card-click')
  }, ___EmotionJSX("h2", {
    css: styles.cardName
  }, agencyName))), ___EmotionJSX("div", {
    css: styles.cardAddress
  }, "".concat(data.address, ", ").concat(data.suburb, " ").concat(data.state, " ").concat(data.postcode)));
  var getAgentDetails = () => ___EmotionJSX("div", {
    css: styles.cardDetails
  }, ___EmotionJSX("div", {
    css: styles.logo
  }, agencyPhoto ? ___EmotionJSX("img", {
    src: agencyPhoto,
    alt: agentStaffName
  }) : ___EmotionJSX("img", {
    src: placeholder,
    alt: agentStaffName,
    css: styles.placeholder
  })), ___EmotionJSX("div", null, ___EmotionJSX("a", {
    href: data.agentUrl,
    css: styles.cardAnchor,
    onClick: () => sendEvent('card-click')
  }, ___EmotionJSX("h2", {
    css: styles.agentStaffName
  }, agentStaffName))), data.jobTitle && ___EmotionJSX("div", {
    css: styles.jobTitle
  }, data.jobTitle), ___EmotionJSX("div", {
    css: styles.agentName
  }, agencyName));
  var getStats = () => ({
    soldAll: sold ? data.soldAll : undefined,
    saleAll: sold ? data.salesAll : undefined,
    sold: sold ? data.sold : undefined,
    sale: sold ? data.sales : undefined,
    averageDaysAll: data.daysOnMarketAll,
    averageDays: data.daysOnMarket,
    rentedAll: rented ? data.rentedAll : undefined,
    rentAll: rented ? data.rentalsAll : undefined,
    rented: rented ? data.rented : undefined,
    rent: rented ? data.rentals : undefined,
    sortAll: sortAll ? true : undefined,
    soldDevelopments: development ? data.soldDevelopments : undefined,
    soldDevelopmentsAll: development ? data.soldDevelopmentsAll : undefined,
    developments: development ? data.developments : undefined,
    developmentsAll: development ? data.developmentsAll : undefined
  });
  return ___EmotionJSX("div", {
    key: agentStaffId,
    css: styles.cardContainer
  }, ___EmotionJSX("div", {
    css: styles.nameContainer
  }, ___EmotionJSX("div", null, isAgencyCard ? getLogo() : getAvatar(), !isAgencyCard && ___EmotionJSX("span", {
    css: styles.logoMobile
  }, agencyPhoto ? ___EmotionJSX("img", {
    src: agencyPhoto,
    alt: agentStaffName
  }) : ___EmotionJSX("img", {
    src: placeholder,
    alt: agentStaffName,
    css: styles.placeholder
  })), ___EmotionJSX("span", {
    css: styles.rightIconMobile
  }, ___EmotionJSX(RightChevron, {
    size: "regular"
  }))), ___EmotionJSX("div", {
    css: styles.detailsColumn
  }, isAgencyCard ? getAgencyDetails() : getAgentDetails()), ___EmotionJSX("div", {
    css: styles.rightIcon
  }, ___EmotionJSX(RightChevron, {
    size: "regular"
  })), mobile && cardType === 'AGENT' && true && renderAwards(false), ___EmotionJSX(ContactButtons, {
    launchEnquiryModal: launchEnquiryModal,
    emailContactable: data.emailContactable,
    phone: data.phone
  })), !mobile && cardType === 'AGENT' && true && renderAwards(true), ___EmotionJSX("div", null, ___EmotionJSX(Stats, _extends({
    titleLeft: statsTitle,
    titleRight: titleRight()
  }, getStats()))));
};
Card.propTypes = {
  data: PropTypes.shape({
    // Agency and agent/agency shared fields:
    agencyId: PropTypes.number.isRequired,
    agencyName: PropTypes.string.isRequired,
    suburb: PropTypes.string,
    postcode: PropTypes.string,
    state: PropTypes.string,
    agencyPhoto: PropTypes.string,
    address: PropTypes.string,
    phone: PropTypes.string,
    emailContactable: PropTypes.bool,
    agencyUrl: PropTypes.string,
    // Agent-specific fields:
    agentStaffId: PropTypes.number,
    agentStaffName: PropTypes.string,
    agentStaffPhotoSmall: PropTypes.string,
    agentUrl: PropTypes.string,
    jobTitle: PropTypes.string,
    // Stats fields:
    sold: PropTypes.string,
    soldAll: PropTypes.string,
    sales: PropTypes.string,
    salesAll: PropTypes.string,
    rented: PropTypes.string,
    rentedAll: PropTypes.string,
    rentals: PropTypes.string,
    rentalsAll: PropTypes.string,
    developments: PropTypes.string,
    developmentsAll: PropTypes.string,
    soldDevelopments: PropTypes.string,
    soldDevelopmentsAll: PropTypes.string,
    daysOnMarket: PropTypes.string,
    daysOnMarketAll: PropTypes.string,
    highlightedAwards: PropTypes.arrayOf(PropTypes.shape({
      badgeLabel: PropTypes.string.isRequired
    }))
  }).isRequired,
  launchEmailEnquiryModal: PropTypes.func,
  statsTitle: PropTypes.string.isRequired,
  cardType: PropTypes.oneOf(['AGENCY', 'AGENT']).isRequired,
  sort: PropTypes.oneOf(['SOLD', 'SOLD_TOTAL', 'RENTED', 'RENTED_TOTAL', 'DEVELOPMENT', 'DEVELOPMENT_TOTAL']).isRequired
};
Card.defaultProps = {
  launchEmailEnquiryModal: () => {}
};
export default withEventBoundary(_ref2 => {
  var cardType = _ref2.cardType,
    data = _ref2.data;
  return {
    name: "".concat(cardType.toLowerCase(), "-card"),
    data: {
      agencyId: data.agencyId,
      agencyName: data.agencyName,
      agentId: data.agentStaffId,
      agentName: data.agentStaffName
    }
  };
})(Card);